export enum JOB_STATUS {
  COMPLETED = 'Completed',
  INPROGRESS = 'In Progress',
  STARTED = 'Started',
  FAILED = 'Failed',
  CANCELLED = 'Cancelled'
}
